module.exports = __webpack_public_path__ + "img/version_control.14fdfe4d.svg";